import {
    request
} from './request.js'

// 创建支付订单
export function CreateOrder(id){
	return request({
		url:'/api2/StudentAccommodationApi/PayCostWeb/CreateOrder',
		method:'post',
		data:id
	})
}
//支付详情页
export function GetPayCostDetailDto(id){
	return request({
		url:'/api2/StudentAccommodationApi/PayCostWeb/GetOrder',
		method:'get',
		params:{orderId:id}
	})
}

// 微信支付
export function WeiXinNumPay(id,exitUrl,successUrl) {
	return request({
		url: '/api2/StudentAccommodationApi/PayCostWeb/WeiXinNumPay',
		method: 'post',
		params: {
			orderId: id,
			exitUrl: exitUrl, // 返回JSAPI信息支付中途退出的URL地址
			successUrl: successUrl, // 返回JSAPI信息支付成功后跳转的URL地址
			openId: ''
		}
	})
}
// 支付宝支付
export function AlipayPayment(id,exitUrl,successUrl) {
	return request({
		url: '/api2/StudentAccommodationApi/PayCostWeb/AlipayPayment',
		method: 'post',
		params: {
			orderId: id,
			exitUrl: exitUrl, // 返回JSAPI信息支付中途退出的URL地址
			successUrl: successUrl // 返回JSAPI信息支付成功后跳转的URL地址
		}
	})
}